import Slider from '@mui/material/Slider';
import { FC } from 'react';
import { IRangeSlider } from './types';
import styles from './styles.module.css';

export const RangeSlider: FC<IRangeSlider> = ({
  min,
  max,
  value,
  onChange,
  ...rest
}) => {
  return (
    <Slider
      value={value}
      min={min}
      max={max}
      onChange={onChange}
      valueLabelDisplay="on"
      classes={{
        root: styles.root,
        thumb: styles.thumb,
        rail: styles.rail,
        track: styles.track,
        valueLabel: styles.valueLabel,
      }}
      {...rest}
    />
  );
};
